
import { createElement, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { nativeType, useDrop } from "../../Bindings/Fable.ReactDnD.js";
import { item, equalsWith } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { createObj, stringHash, defaultOf, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton as singleton_1, ofArray, contains } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Dialog } from "../../Components/Dialog.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextButton } from "../../Components/Button.js";
import { ImageUpload } from "./ImageUploadDnD.js";

export function ImageUploadDialog(props) {
    let Title, elems_3, elems_1, elems, elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = useState(undefined);
    const setCurrentFile = patternInput_1[1];
    const currentFile = patternInput_1[0];
    const dependencies = [props.IsOpen];
    reactApi.useEffect(() => {
        setCurrentFile((_arg_1) => undefined);
    }, dependencies);
    const uploadFile = (file) => {
        setCurrentFile((_arg_2) => file);
        const img = document.getElementById("img-preview");
        const url = URL.createObjectURL(file);
        img.src = url;
    };
    const patternInput_2 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let testExpr, testExpr_1;
            const matchValue = draggedFile.files;
            if (matchValue == null) {
            }
            else if ((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) {
            }
            else if ((testExpr_1 = matchValue, !equalsWith(equals, testExpr_1, defaultOf()) && (testExpr_1.length === 1))) {
                const file_1 = item(0, matchValue);
                if (contains(file_1.type, ofArray(["image/jpeg", "image/png"]), {
                    Equals: (x_2, y_2) => (x_2 === y_2),
                    GetHashCode: (x_2) => (stringHash(x_2) | 0),
                })) {
                    uploadFile(file_1);
                }
            }
        },
    });
    const dropData = patternInput_2[0];
    return createElement(Dialog, (Title = t("general.upload_image"), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("items-center"), delay(() => append(singleton("mt-4"), delay(() => append(singleton("mb-4"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("border"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => ((dropData.canDrop && dropData.isOver) ? singleton("bg-background") : empty()))))))))))))))))))))))))], ["ref", patternInput_2[1]], (elems_1 = [reactElement("img", {
            className: join(" ", toList(delay(() => append(singleton("shadow"), delay(() => append(singleton("rounded"), delay(() => append(singleton("border-none"), delay(() => append(singleton("max-h-64"), delay(() => ((currentFile != null) ? singleton("mt-4") : empty())))))))))))),
            id: "img-preview",
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "mb-4"])], (elems = [createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("file_upload.select_file"),
            OnClick: () => {
                const element = document.getElementById("file-upload");
                element.click();
            },
            TestId: "open-file-explorer-test-id",
            Variant: "blueButton",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_2 = [reactElement("input", {
            id: "file-upload",
            className: join(" ", ["hidden"]),
            type: "file",
            accept: ".jpg, .jpeg, .png",
            onChange: (ev) => {
                const files = ev.target.files;
                if (!(files == null) && (files.length > 0)) {
                    uploadFile(files.item(0));
                }
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))),
        Controls: toList(delay(() => {
            let elems_4;
            return append((props.ImageUrl == null) ? (empty()) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mr-auto"])], (elems_4 = [createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("general.delete"),
                OnClick: props.OnDeleteImage,
                TestId: "delete-image-test-id",
                Variant: "redButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => append(singleton(createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("general.cancel"),
                OnClick: props.OnClose,
                TestId: "close-upload-dialog-test-id",
                Variant: "blueButton",
            })), delay(() => {
                let Label_3;
                return singleton(createElement(TextButton, (Label_3 = t("general.upload_image"), {
                    ComponentState: (currentFile == null) ? "disabled" : "enabled",
                    Label: Label_3,
                    OnClick: () => {
                        if (currentFile == null) {
                        }
                        else {
                            props.OnUploadImage(currentFile);
                        }
                    },
                    TestId: "upload-file-button-test-id",
                    Variant: "blueButton",
                })));
            }))));
        })),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

export function MultipleImageUploadDialog(props) {
    let Title, elems;
    const t = useTranslation()[0];
    return createElement(Dialog, (Title = t("general.upload_image"), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(ImageUpload, {
            ComponentState: "enabled",
            SelectedFiles: props.Images,
            SetSelectedFile: props.SetImages,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: props.ComponentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-upload-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: props.ComponentState,
            Label: t("general.save"),
            OnClick: props.OnSave,
            TestId: "upload-file-button-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

